import { useTranslation } from 'react-i18next';
import { useFacialRegistrationContext } from '../../../../../../store/FacialRegistration';
import StepLayout from './StepLayout';
import * as S from './styles';
import { CheckboxTerm, Button } from './common';

const StepConfirmation = () => {
  const [t] = useTranslation('personalized-invite');
  const {
    capturedImage,
    confirmPhoto,
    retakePhoto,
    primaryColor,
    secondaryColor,
    previousStep,
    storePhoto,
    setStorePhoto,
    loading,
  } = useFacialRegistrationContext();

  const handleConfirm = () => {
    confirmPhoto();
  };

  const footer = (
    <S.WrapperFooter>
      <CheckboxTerm
        id="photo-terms-checkbox"
        checked={storePhoto}
        onChange={e => setStorePhoto(e.target.checked)}
        accentColor={primaryColor}
      >
        <span>{t('facial-registration.confirmation.use-photo-terms')}</span>
      </CheckboxTerm>

      <S.ButtonsRow>
        <Button variant="outlined" onClick={retakePhoto} color={secondaryColor}>
          {t('facial-registration.confirmation.retake-button')}
        </Button>
        <Button
          variant="primary"
          onClick={handleConfirm}
          color={primaryColor}
          disabled={loading}
        >
          {t('facial-registration.confirmation.confirm-button')}
        </Button>
      </S.ButtonsRow>
    </S.WrapperFooter>
  );

  return (
    <StepLayout footer={footer} onBack={previousStep}>
      <S.StepTitle>{t('facial-registration.confirmation.title')}</S.StepTitle>
      <S.StepDescription>
        {t('facial-registration.confirmation.description')}
      </S.StepDescription>

      <S.PreviewContainer>
        {capturedImage && (
          <S.PreviewImage
            src={capturedImage}
            alt={t('facial-registration.confirmation.captured-photo-alt')}
          />
        )}
      </S.PreviewContainer>
    </StepLayout>
  );
};

export default StepConfirmation;
